import { Form as HeroForm, FormProps as HeroFormProps } from "@heroui/react";
import clsx from "clsx";
import { forwardRef } from "react";

export type FormProps = Omit<HeroFormProps, "children"> & {
  children: React.ReactNode;
};

export const Form = forwardRef<HTMLFormElement, FormProps>((props, ref) => {
  return (
    <HeroForm
      {...props}
      ref={ref}
      className={clsx("flex flex-col gap-4", props.className)}
    />
  );
});

Form.displayName = "Recare.Form";
